import React from "react";
import {Asset} from "../../../plugins/gatsby-plugin-atollon";
import {EdlynLogo} from "../icons";

const TeamCard = (props) => {
    return (
        <div key={props.key} onClick={props.onClick} className='card card--team' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
            <div className='card--team__image'>
                {props.image && <Asset asset={props.image}/>}
                <EdlynLogo/>
            </div>

            <div className='card--team__info'>
                {props.sector?.length > 0 && <span>{props.sector[0]?.option}</span>}
                {props.title && <h4>{props.title}</h4>}
                {props.jobTitle && <p>{props.jobTitle}</p>}
            </div>
        </div>
    )
}

export default TeamCard